import { render, staticRenderFns } from "./interact.vue?vue&type=template&id=0f3da218&"
import script from "./interact.vue?vue&type=script&lang=js&"
export * from "./interact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports